import script from "./CompareFat.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareFat.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__